import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { lightTheme, darkTheme } from "./index";
import { getAccountDetails } from "../core/storage/localStorage";

const ThemeSettingsContext = createContext({
  mode: "dark",
  toggleMode: () => {},
  setMode: () => {},
});

export function ThemeSettingsProvider({ children }) {
  const account = getAccountDetails();
  const [mode, setMode] = useState(() => {
    try {
      const saved = localStorage.getItem("themeMode");
      return saved === "light" || saved === "dark" ? saved : "dark";
    } catch (_) {
      return "dark";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("themeMode", mode);
    } catch (_) {}
  }, [mode]);

  const toggleMode = useCallback(() => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  }, []);

  const theme = useMemo(
    () => (mode === "dark" ? darkTheme : lightTheme),
    [mode]
  );

  const contextValue = useMemo(
    () => ({ mode, toggleMode, setMode }),
    [mode, toggleMode]
  );

  return (
    <ThemeSettingsContext.Provider value={contextValue}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeSettingsContext.Provider>
  );
}

export function useThemeSettings() {
  return useContext(ThemeSettingsContext);
}
